import {configureStore, EnhancedStore} from '@reduxjs/toolkit';

import {reducer} from '../reducers';

export const store:EnhancedStore = configureStore({
    reducer,
    devTools: true
});